import { currentLocale } from '@web/i18n';

// The date/duration formatters moved to `ui/core/utils` (the alerts panel and the
// voucher detail organism are shared); re-exported so this feature's callers keep
// one import site.
export { formatDate, formatRawDate } from '@web/ui/core/utils';

/**
 * Formats a dossier monetary amount in the active locale's currency style
 * (e.g. `R$ 1.962,01` for BRL in pt-BR). The non-breaking space `Intl` inserts
 * after the symbol is normalised to a regular space so the rendered string is
 * predictable. Falls back to `<code> <fixed>` for an invalid ISO currency code,
 * or a bare fixed number when no currency is given. Null amount renders a dash.
 */
export function formatAmount(amount: number | null, currency: string | null): string {
  if (amount === null) return '—';
  if (currency) {
    try {
      return new Intl.NumberFormat(currentLocale(), { style: 'currency', currency })
        .format(amount)
        .replaceAll(/[\u00a0\u202f]/g, ' ');
    } catch {
      // Invalid ISO 4217 code — fall through to the code + fixed-decimals form.
      return `${currency} ${amount.toFixed(2)}`;
    }
  }
  return amount.toFixed(2);
}
